module.exports = "https://static.wmbcdn.com/uniweb/images/1de9e0f96a4540fe5630324ce2c517ec.svg";